import { saveAs } from "file-saver";
import {
    Document,
    Packer,
    Paragraph,
    HeadingLevel,
    TextRun,
} from "docx";
import i18n from "../../../../i18n";

type ContentType = {
    content_name: string;
    content_detail: string;
    content_start_date: string;
    content_end_date: string;
};

export async function exportToWord(data: ContentType) {
    const title = new Paragraph({
        text: data.content_name,
        heading: HeadingLevel.HEADING_1,
        spacing: { after: 300 },
    });

    const detailText = data.content_detail
        .replace(/<\/?[^>]+(>|$)/g, "")
        .trim();

    const detail = new Paragraph({
        children: [new TextRun(detailText)],
    });

    const doc = new Document({
        sections: [
            {
                properties: {},
                children: [
                    title,
                    new Paragraph({
                        text: i18n.t("📅 เริ่ม: {{date}}", { date: new Date(data.content_start_date).toLocaleString() }),
                    }),
                    new Paragraph({
                        text: i18n.t("📅 สิ้นสุด: {{date}}", { date: new Date(data.content_end_date).toLocaleString() }),
                    }),
                    new Paragraph(""),
                    detail,
                ],
            },
        ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${data.content_name}.docx`);
}
